module.exports = __webpack_public_path__ + "img/club.0b83dcba.png";